/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-08 17:51:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-08-25 15:00:04
 */
import store from '../store'
function authInserted(el, binding) {
  if (store.state.user.authorityList && store.state.user.authorityList.length) {
    const list = store.state.user.authorityList
      .filter(item => item.isShow === 1)
      .map(item => item.actionCode)
    const auth = binding.value ? `shop-management::${binding.value}` : 'shop-management'
    if (!list.includes(auth)) {
      const parent = el.parentNode
      parent.removeChild(el)
    }
  } else {
    const parent = el.parentNode
    parent.removeChild(el)
  }
}
/**
 * @desc 按钮权限指令
 * @param {*} Vue
 * @use  在需要验证权限按钮添加 v-auth， 例如： v-auth="'stores::propManagement'"
 */
export default Vue => {
  Vue.prototype.$auth = val => {
    if (store.state.user.authorityList && store.state.user.authorityList.length) {
      const list = store.state.user.authorityList
        .filter(item => item.isShow === 1)
        .map(item => item.actionCode)
      const auth = val ? `shop-management::${val}` : 'shop-management'
      return list.includes(auth)
    } else {
      return false
    }
  }
  // 权限指令
  Vue.directive('auth', {
    inserted: (el, binding) => {
      authInserted(el, binding)
    }
  })
}
